import React from 'react';
import { Link } from 'react-router-dom';
import { Button, IconButton, Tooltip } from '@mui/material';
import { Lock, LockOpen } from '@mui/icons-material';
import { isAllowed } from 'helpers';

export const getColumns = (intl, user, handleBlockCorporative) => [
  {
    field: 'name',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.grid.colName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'market_segment',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.grid.colMarkSeg',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'active',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.statusCorp',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    renderCell: (rowData) =>
      rowData.row.active === 0
        ? intl.formatMessage({ id: 'app.users.usersList.unlocked' })
        : intl.formatMessage({ id: 'app.users.usersList.locked' }),
  },
  {
    field: 'city',
    headerName: intl.formatMessage({
      id: 'app.users.usersList.grid.colCity',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: intl.formatMessage({
      id: 'app.users.usersList.grid.colUsersList',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    renderCell: (rowData) => (
      <Link
        to={{
          pathname: `/users/${rowData.row.id}`,
          state: { rowData: rowData.row },
        }}
        style={{ textDecoration: 'none' }}
      >
        <Button variant="outlined" color="secondary" size="small">
          {intl.formatMessage({
            id: 'app.users.usersList.grid.colUsersList.btnSeeUsers',
          })}
        </Button>
      </Link>
    ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    renderCell: (params) => {
      if (isAllowed(user.permissions, ['corporative_update'])) {
        return (
          <Tooltip title={params.row.active === 0 ? 'Bloquear' : 'Desbloquear'}>
            <IconButton onClick={() => handleBlockCorporative(params.row)}>
              {params.row.active === 1 ? <Lock /> : <LockOpen />}
            </IconButton>
          </Tooltip>
        );
      }
      return null;
    },
  },
];
